import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useDidMountEffect } from '../hooks';
import PriceLabel from './price-label';

const AnimatedPriceLabel = props => {
    const { price } = props;
    const [showAnimation, setShowAnimation] = useState(false);
    useDidMountEffect(() => {
        setShowAnimation(true);
        const timer = setTimeout(() => {
            setShowAnimation(false);
        }, 500);
        return () => clearTimeout(timer);
    }, [price]);
    const priceLabelProps = {
        ...props,
        className: `${props.className}${
            showAnimation ? ' item-card-details-price-highlight' : ''
        }`
    };
    return <PriceLabel {...priceLabelProps} />;
};
AnimatedPriceLabel.propTypes = {
    tagName: PropTypes.string,
    className: PropTypes.string,
    price: PropTypes.number,
    hasDiscount: PropTypes.bool
};
AnimatedPriceLabel.defaultProps = {
    tagName: 'span',
    className: ''
};

export default AnimatedPriceLabel;
